import './AdvantagesItem.styles.scss';

import PropTypes from 'prop-types';

import Title from '../../Title/Title';
import Text from '../../Text/Text';

const AdvantagesItem = ({ icon, title, text }) => {
    return (
        <li className="advantages__item flex flex--column align-center">
            <div className="advantages__item-icon flex">
                <img src={icon} alt={title} />
            </div>

            <Title name="advantages" type="h3" size="smallest">
                {title}
            </Title>

            <Text name="advantages" grey={true}>
                {text}
            </Text>
        </li>
    );
};

AdvantagesItem.propTypes = {
    icon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
};

export default AdvantagesItem;
